import script from "./HomeContent.vue?vue&type=script&lang=ts&setup=true"
export * from "./HomeContent.vue?vue&type=script&lang=ts&setup=true"

import "./HomeContent.vue?vue&type=style&index=0&id=212b87e2&lang=scss"

const __exports__ = script;

export default __exports__